import {Vue} from "ui.vue";

export let BasketLine = {
	name: 'BasketLine',
	store: BX.Citrus.Vuex.store,
	data: function() {
		return {
			url: "",
			products: 0
		};
	},
	computed: {
		loc: () => Object.freeze(Vue.getFilteredPhrases("BASKET_LINE_")),
		productCount: function () {
			return this.$store.getters['basket/count'];
		},
		totalPrice: function () {
			return this.$store.getters['basket/totalPrice'];
		},
		isActive: function() {
			return (this.productCount > 0);
		}
	},
	created: function() {
		this.$store.dispatch('basket/load');

		Vue.event.$on('Citrus.Component.Basket:update', () => {
			this.$store.dispatch('basket/load');
		});
	},
	beforeDestroy: function () {

	}
};

export default {BasketLine};
